import axios from 'axios'

export async function getCusip(cusip) {
  return await axios.get(process.env.VUE_APP_API_HOST + `/cusips/${cusip}`)
}

export async function getProperties(cusip, drive_time) {
  return await axios.get(process.env.VUE_APP_API_HOST + `/cusips/${cusip}/properties`, {
    params: {drive_time: drive_time}
  })
}

export async function getSummaryData(cusip, drive_time) {
  return await axios.get(process.env.VUE_APP_API_HOST + `/cusips/${cusip}/summary_data`, {
    params: {drive_time: drive_time}
  })
}

export async function getSummaryData2(cusip) {
  return await axios.get(process.env.VUE_APP_API_HOST + `/cusips/${cusip}/summary`)
}
